"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faraday = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const CardRenderItem_1 = require("../render/CardRenderItem");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class Faraday extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.FARADAY,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L27',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.text('5', Size_1.Size.LARGE).diverseTag(1, Size_1.Size.MEDIUM).played.colon().megacredits(-3).cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.DIVERSE).asterix();
                    b.br.br;
                }),
                description: 'When you gain a multiple of 5 for any tag type IN PLAY, you may pay 3 M€ to draw a card with that tag. Wild tags do not count for this effect.',
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return false;
    }
    action() {
        return undefined;
    }
    onCardPlayed(player, card) {
        if (card.cardType === CardType_1.CardType.EVENT)
            return;
        if (!player.cardIsInEffect(this.name))
            return;
        const validTags = player.getAllTags()
            .filter((item) => [Tags_1.Tags.WILDCARD, Tags_1.Tags.EVENT].includes(item.tag) === false)
            .filter((item) => card.tags.includes(item.tag));
        validTags.forEach((item) => {
            const count = item.count;
            const tagsAdded = card.tags.filter((tag) => tag === item.tag).length;
            if (count % 5 === 0) {
                player.game.defer(new DeferredAction_1.DeferredAction(player, () => this.effectOptions(player, item.tag)), DeferredAction_1.Priority.PAY_TO_DRAW_CARDS);
            }
            else if (tagsAdded > 1 && (count - 1) % 5 === 0) {
                player.game.defer(new DeferredAction_1.DeferredAction(player, () => this.effectOptions(player, item.tag)), DeferredAction_1.Priority.PAY_TO_DRAW_CARDS);
            }
        });
    }
    effectOptions(player, tag) {
        const orOptions = new OrOptions_1.OrOptions();
        if (player.canAfford(3)) {
            orOptions.options.push(new SelectOption_1.SelectOption(`Pay 3 M€ to draw a ${tag} card`, 'Confirm', () => {
                player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3, { title: 'Select how to pay for card' }), DeferredAction_1.Priority.COST);
                player.drawCard(1, { tag: tag });
                return undefined;
            }));
        }
        orOptions.options.push(new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
            return undefined;
        }));
        if (orOptions.options.length === 1) {
            player.game.log('${0} cannot afford to pay 3 M€ to draw a ${1} card', (b) => b.player(player).string(tag));
            return orOptions.options[0].cb();
        }
        return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption(`Pay 3 M€ to draw a ${tag} card`, 'Confirm', () => {
            player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3, { title: 'Select how to pay for card' }));
            player.game.log('${0} paid 3 M€ to draw a ${1} card', (b) => b.player(player).string(tag));
            player.drawCard(1, { tag: tag });
            return undefined;
        }), new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
            return undefined;
        }));
    }
}
exports.Faraday = Faraday;
//# sourceMappingURL=Faraday.js.map